/*
 * @Author: 张帮辉
 * @LastEditors: 赵泽文
 * @Date: 2022-03-09 14:18:26
 * @LastEditTime: 2025-02-08 17:28:59
 * @Description: file content
 */
/**
 * @param device_id 设备id
 * @param access_token 请求携带token
 * @param refresh_token 刷新token
 * @param merchant_id 商户id
 * @param operator 操作人
 * @param distribution_center_is 是否为配送中心
 * @param headquarters_is 是否为总部
 * @param direct_is 是否为直营店
 * @param location_name 门店名称
 * @param location_id 门店id
 * @param staff_id 员工id
 * @param role_id 角色id
 * @param old_mars_token 原mars_token用来对比登陆是否过期
 * @param location_zone_id mars location zone id
 * @param zone_is 是否是区域
 * @param account_id 账户id
 * @param scopeType  'HEADQUARTERS' | 'ZONE' | 'BRANCH'
 * @param convert_actual_item 虚拟物品转换方式 fasle:虚拟物品不转实际物品 true:虚拟物品转实际物品
 */

class StorageHanlder {
  public storage: Storage;
  public name: string;
  constructor(isLocal = true) {
    this.storage = isLocal ? localStorage : sessionStorage;
    this.name = '';
  }

  /** 遍历 */
  key(index: number) {
    return this.storage.key(index);
  }

  /** 获取长度 */
  length() {
    return this.storage.length;
  }

  /** 存值 */
  setItem(key: string, value: any) {
    this.storage.setItem(this.name + key, JSON.stringify(value));
  }

  /**
   * 判断字符串是否可以被JSON.parse 避免解析错误
   * @param str
   * @returns {boolean}
   */

  /**
   * 获取localStorage数据
   * @description 注意：因为主项目进销存缓存存储方式不同，项目合并前，主项目使用cookie，进销存使用localstorage，注意区分location_id的不同
   * @description localstorage中的location_id在总部进入时显示为总部门店id，区域进入显示区域下第一家门店id，门店进入显示门店id；mars_location_id的数据同cookie中的location_id
   * @description cookie中的location_id在总部或区域进入显示总部或区域下第一家门店id，门店进入显示门店id
   */
  getItem(key: string) {
    const value = this.storage.getItem(this.name + key);
    // 避免一些特殊字符的处理
    try {
      return value ? JSON.parse(value) : '';
    } catch (error) {
      return value ?? '';
    }
  }

  /** 删值 */
  removeItem(key: string) {
    this.storage.removeItem(this.name + key);
  }

  /** 遍历删除 */
  clearAll(args?: { excludeKeys?: string[] }) {
    // 获取所有需要删除的keys
    const keys: string[] = [];
    for (let i = 0; i < this.storage.length; i++) {
      const key = this.storage.key(i);
      if (key) {
        keys.push(key);
      }
    }
    keys.forEach((key) => {
      if (key) {
        if (args?.excludeKeys && args.excludeKeys?.length > 0) {
          if (
            (this.name &&
              key.indexOf(this.name) > -1 &&
              args?.excludeKeys?.includes(key.split(this.name)?.[1])) ||
            args?.excludeKeys?.includes(this.name)
          ) {
            return;
          }
        }
        this.storage.removeItem(key);
      }
    });
  }

  /**
   * 清空所有
   * @param all 是否需要删除deviceId
   */
  clear(all?: boolean) {
    if (!all) {
      const deviceId = this.getItem('device_id');
      if (deviceId) {
        this.clearAll();
        this.setItem('device_id', deviceId);
      }
    } else {
      this.clearAll();
    }
  }
}

const localCache = new StorageHanlder();
const sessionCache = new StorageHanlder(false);

export { localCache, sessionCache };
